import React from 'react';
import Css from '@components/Quoting/Board/Pricing/PricingRow/PricingRow.scss';
import { Row, Col } from 'reactstrap';
import CurrencyFormat from 'react-currency-format';
import ImportImages from '@src/importImages';
import PriceTooltip from '@components/Quoting/Board/Pricing/PricingRow/PriceTooltip/PriceTooltip';

/*const P100 = ImportImages('/quoting/p100.png');
const P300 = ImportImages('/quoting/p300.png');
const L650 = ImportImages('/quoting/L650.png');*/
const P100 = ImportImages('/compare/p100.png');
const P300 = ImportImages('/compare/p300.png');
//const L650 = ImportImages('/compare/l650.png');

const tripSummary = props => {
  const { isMobile, P100Total, P300Total, p300Only, contractVersion } = props;
  return (
    <React.Fragment>
      <div
        className={'text-uppercase color-red font-sm lakes-bold mt-3 text-left'}
      >
        Trip Summary
      </div>
      <div className={Css.content + ' background-white p-3'}>
        <Row>
          <Col className={'font-sm text-center'}>
            <div className={'lakes-demibold'}>
              JetSuite Phenom 100
              <PriceTooltip
                tooltipOpen={props.tooltipOpen}
                index={`p100-total`}
                toggleTooltip={props.toggleTooltip}
                fees={[]}
                items={[
                  'JetSuite Phenom 100s are priced primarily to fly in the West and Texas.'
                ]}
                title={false}
              />
            </div>
            <div className={'lakes-demibold color-dark-grey pb-2'}>4 Seats</div>
            <img
              src={P100}
              className={'mx-auto img-fluid ' + Css['image-circle']}
              alt={'Phenom 100'}
              style={isMobile ? { width: '50px' } : { width: '120px' }}
            />
          </Col>
          <Col className={'font-sm text-center'}>
            <div className={'lakes-demibold'}>
              JetSuite Phenom 300
              <PriceTooltip
                tooltipOpen={props.tooltipOpen}
                index={`p300-total`}
                toggleTooltip={props.toggleTooltip}
                fees={[]}
                items={[
                  'JetSuite Phenom 300s are priced primarily to fly East of the Mississippi.'
                ]}
                title={false}
              />
            </div>
            <div className={'lakes-demibold color-dark-grey pb-2'}>7 Seats</div>
            <img
              src={P300}
              className={'mx-auto img-fluid ' + Css['image-circle']}
              alt={'Phenom 300'}
              style={isMobile ? { width: '50px' } : { width: '120px' }}
            />
          </Col>
          {/*<Col className={'font-sm text-center'}>
            <div className={'lakes-demibold'}>JetSuite Legacy L650</div>
            <div className={'lakes-demibold color-dark-grey pb-2'}>
              13 Seats
            </div>
            <img
              src={L650}
              className={'mx-auto img-fluid'}
              alt={'Legacy L650'}
              style={isMobile ? { width: '50px' } : { width: '120px' }}
            />
          </Col>*/}
        </Row>

        <Row>
          <Col className={'text-center color-red'}>
            {contractVersion !== 2 && (
              <React.Fragment>
                <div
                  className={
                    'color-red font-sm lakes-demibold text-center pt-2 pb-0'
                  }
                  style={{ lineHeight: '15px' }}
                >
                  Total Trip Price:
                </div>
                <div className={'lakes-bold font-sm'}>
                  {P100Total > 0 && p300Only === false ? (
                    <CurrencyFormat
                      value={P100Total}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={'$'}
                      decimalScale={2}
                      fixedDecimalScale={true}
                    />
                  ) : (
                    'Not Available'
                  )}
                </div>
              </React.Fragment>
            )}
          </Col>
          <Col className={'text-center color-red'}>
            {contractVersion !== 2 && (
              <React.Fragment>
                <div
                  className={
                    'color-red font-sm lakes-demibold text-center pt-2 pb-0'
                  }
                  style={{ lineHeight: '15px' }}
                >
                  Total Trip Price:
                </div>
                <div className={'lakes-bold font-sm'}>
                  {P300Total > 0 ? (
                    <CurrencyFormat
                      value={P300Total}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={'$'}
                      decimalScale={2}
                      fixedDecimalScale={true}
                    />
                  ) : (
                    'Not Available'
                  )}
                </div>
              </React.Fragment>
            )}
          </Col>
          {/*<Col
            className={'text-center color-red lakes-demibold font-xs pt-2'}
            style={{ lineHeight: '12px' }}
          >
            For Legacy pricing, please contact JetSuite Guest Services or your
            Sales Manager.
          </Col>*/}
        </Row>
        <Row className={'pt-2'}>
          <Col className={'text-center color-red'}>
            {p300Only === false ? (
              <button
                className={'btn btn-fullred btn-sm pt-2'}
                onClick={() => props.selectAircraft('E50P')}
              >
                P100
              </button>
            ) : (
              <button className={'btn btn-sm btn-grey pt-2 disabled'}>
                P100
              </button>
            )}
          </Col>
          <Col className={'text-center color-red'}>
            <button
              className={'btn btn-fullred btn-sm pt-2'}
              onClick={() => props.selectAircraft('525B')}
            >
              P300
            </button>
          </Col>
          {/*<Col className={'text-center color-red'}>
            <button className={'btn btn-sm btn-grey pt-2 disabled'}>
              L650
            </button>
          </Col>*/}
        </Row>
      </div>

      <div
        className={'text-uppercase color-red font-sm lakes-bold mt-3 text-left'}
      >
        Please Note
      </div>
      <div className={'lakes-demibold font-sm text-left'}>
        Peak day travel, trips requested within 48 hours, and catering requests
        may require additional assistance from Guest Services.
      </div>
    </React.Fragment>
  );
};

export default tripSummary;



// WEBPACK FOOTER //
// ./src/components/Quoting/Board/Pricing/TripSummary/TripSummary.jsx